import { Badge, Icon, IconButton } from '@hevoio/hevo-ui-toolkit';
import styles from './ContactSupportHeader.module.scss';
import {
  IconArrowNarrowLeft,
  IconChevronDown,
  IconMessageCircleUser,
  IconMinus,
  IconViewportTall
} from '@tabler/icons-react';
import clsx from 'clsx';
import { HEVO_FAVICON_LIGHT_SVG } from '../../../../shared/constants/brand-logo';
 interface ContactSupportHeaderProps {
  hideBackButton: boolean;
  onMaximize: () => void;
  onMinimize: () => void;
  maximized: boolean;
  onClose: () => void;
  onBack: () => void;
  openSupportChat: () => void;
  badgeContent: number | null;
}

export default function ContactSupportHeader({
  hideBackButton,
  onMaximize,
  onMinimize,
  maximized,
  onClose,
  onBack,
  openSupportChat,
  badgeContent
}: ContactSupportHeaderProps) {
 
  return (
    <div className={clsx(styles.ContactSupportHeader, 'border-bottom')}>
      <div className='d-flex'>
        <div
          className={clsx(hideBackButton ? styles.hideBackButton : styles.showBackButton, 'mr-1')}
        >
          <IconButton
            label={'Go Back'}
            dataId={'back-contact-support'}
            onClick={() => {
              onBack();
            }}
          >
            <Icon SVGIcon={IconArrowNarrowLeft} className={styles.closeIcon} />
          </IconButton>
        </div>

        <div className='d-flex align-items-center'>
          <img src={HEVO_FAVICON_LIGHT_SVG} alt='Hevo' className={styles.headsetIcon} />
          
          <span className='text-label-small pl-3'>Contact Support</span>
        </div>
      </div>
      <div className='d-flex align-items-center'>
        <Badge badgeContent={badgeContent ?? null} color='error'>
          <IconButton
            label={'Live Chat'}
            className='p-0'
            dataId={'help-contact-support'}
            disableFocusRipple
            disableRipple
            onClick={() => {
              openSupportChat();
            }}
          >
            <Icon SVGIcon={IconMessageCircleUser} size={3} className={styles.closeIcon} />
          </IconButton>
        </Badge>
        
        <IconButton
          className='ml-3'
          label={maximized ? 'Minimize' : 'Maximize'}
          dataId={maximized ? 'minimize-contact-support' : 'maximize-contact-support'}
          onClick={maximized ? onMinimize : onMaximize}
        >
          <Icon
            SVGIcon={maximized ? IconMinus : IconViewportTall}
            className={styles.closeIcon}
            size={3}
          />
        </IconButton>

        <IconButton
          label={'Close'}
          dataId={'close-contact-support'}
          onClick={() => {
            onClose();
          }}
        >
          <Icon SVGIcon={IconChevronDown} className={styles.closeIcon} size={3} />
        </IconButton>
      </div>
    </div>
  );
}
